import { Tag, TagLabel } from '@chakra-ui/react';
import { AbsenceType } from '../../types';
import { useSuIntl } from '../../hooks/useSuIntl';

type AbsenceTypeBadgeProps = {
    type: AbsenceType;
    size?: 'sm' | 'md' | 'lg';
};

export const AbsenceTypeBadge: React.FC<AbsenceTypeBadgeProps> = ({ type, size = 'md' }) => {
    const { t } = useSuIntl();
    return (
        <Tag colorScheme="primary" borderRadius="md" size={size}>
            <TagLabel>{t(`absence.type.${type}`)}</TagLabel>
        </Tag>
    );
};
